const CRC32C_POLY = 0x82f63b78;

let crc32cTable = null;

function table() {
  if (crc32cTable) {
    return crc32cTable;
  }
  crc32cTable = new Uint32Array(256);
  for (let i = 0; i < 256; i += 1) {
    let value = i;
    for (let bit = 0; bit < 8; bit += 1) {
      value = (value & 1) ? ((value >>> 1) ^ CRC32C_POLY) : (value >>> 1);
    }
    crc32cTable[i] = value >>> 0;
  }
  return crc32cTable;
}

export function createCrc32c() {
  let crc = 0xffffffff;
  const lookup = table();
  return {
    update(bytes) {
      const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
      for (let i = 0; i < view.length; i += 1) {
        crc = lookup[(crc ^ view[i]) & 0xff] ^ (crc >>> 8);
      }
    },
    hex() {
      return ((crc ^ 0xffffffff) >>> 0).toString(16).padStart(8, "0");
    },
  };
}

export function blobToArrayBuffer(blob) {
  if (blob?.arrayBuffer) {
    return blob.arrayBuffer();
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob);
  });
}

export async function crc32cHexForBlob(blob) {
  const crc = createCrc32c();
  crc.update(await blobToArrayBuffer(blob));
  return crc.hex();
}
